import { Controller } from "@hotwired/stimulus"

/**
 * Admin Jobs Batch Controller
 *
 * Manages batch selection and mass-delete for admin jobs list.
 * Similar to batch_actions for projects/products.
 */
export default class extends Controller {
  static targets = ["listItem", "selectAllCheckbox"]

  connect() {
    this.updateActionCount()
  }

  selectItem(event) {
    if (event.target.closest(".prevent-deselect")) return

    const item = event.currentTarget
    const checkbox = item.querySelector('input[type="checkbox"]')
    if (checkbox) {
      checkbox.checked = !checkbox.checked
      if (checkbox.checked) {
        item.classList.add("selected")
      } else {
        item.classList.remove("selected")
      }
      this.updateActionCount()
    }
  }

  selectCheckbox(event) {
    event.stopPropagation()
    const checkbox = event.target
    const item = checkbox.closest("tr")

    if (checkbox.checked) {
      item.classList.add("selected")
    } else {
      item.classList.remove("selected")
    }

    this.updateActionCount()
  }

  selectAll(event) {
    event.stopPropagation()
    const selectAllCheckbox = event.target
    const isChecked = selectAllCheckbox.checked

    const checkboxes = this.element.querySelectorAll("tbody input[type='checkbox']")

    checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked
      const item = checkbox.closest("tr")
      if (item) {
        if (isChecked) {
          item.classList.add("selected")
        } else {
          item.classList.remove("selected")
        }
      }
    })

    this.updateActionCount()
  }

  updateActionCount() {
    const selectedItems = this.element.querySelectorAll("tr.admin-job-row.selected")
    const count = selectedItems.length

    const deleteButtons = document.querySelectorAll(".admin-jobs-delete-action")
    deleteButtons.forEach((el) => {
      el.style.display = count > 0 ? "inline-block" : "none"
    })

    const actionCountElements = document.querySelectorAll(".admin-jobs-action-count")
    actionCountElements.forEach((el) => {
      el.textContent = count
    })
  }

  deleteJobs(event) {
    event.preventDefault()

    const button = event.currentTarget
    const deleteUrl = button.dataset.deleteUrl
    if (!deleteUrl) {
      console.warn("[AdminJobsBatchController] No delete URL provided")
      return
    }

    const selectedItems = this.element.querySelectorAll("tr.admin-job-row.selected")
    const jobIds = []
    selectedItems.forEach((tr) => {
      const id = tr.dataset.jobId
      if (id) jobIds.push(id)
    })

    if (jobIds.length === 0) return

    const message =
      jobIds.length === 1
        ? "Are you sure you want to delete this job?"
        : `Are you sure you want to delete these ${jobIds.length} jobs?`
    if (!confirm(message)) return

    const form = document.createElement("form")
    form.method = "post"
    form.action = deleteUrl

    const csrf = document.querySelector('meta[name="csrf-token"]')
    if (csrf?.content) {
      const tokenInput = document.createElement("input")
      tokenInput.type = "hidden"
      tokenInput.name = "authenticity_token"
      tokenInput.value = csrf.content
      form.appendChild(tokenInput)
    }

    jobIds.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "job_ids[]"
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
